import type { PermissionSet } from '@/shared/api';

export const EMPTY_PERMISSIONS: PermissionSet = {
  repairOrders: {
    read: false,
    create: false,
    update: false,
    delete: false,
    approve: false,
    overrideApproved: false,
    forceComplete: false,
    viewAudit: false,
    viewFinancials: false,
  },
  customers: { read: false, create: false, update: false, delete: false },
  vehicles: { read: false, create: false, update: false, delete: false },
  inventory: { read: false, create: false, update: false, delete: false },
  appointments: { read: false, create: false, update: false, delete: false },
  invoices: {
    read: false,
    create: false,
    update: false,
    void: false,
    delete: false,
  },
  reports: { read: false, create: false },
  messages: { read: false, send: false, delete: false },
  shopSettings: { read: false, update: false },
  users: {
    read: false,
    create: false,
    update: false,
    delete: false,
    invite: false,
  },
  pricing: { read: false, update: false },
  estimateSettings: { read: false, update: false },
  appointmentSettings: { read: false, update: false },
  integrations: { read: false, update: false },
  timeEntries: {
    readOwn: false,
    readAll: false,
    clockSelf: false,
    clockOnBehalfOf: false,
    manualCreate: false,
    edit: false,
    editApproved: false,
    delete: false,
    approve: false,
  },
  timeTrackingSettings: { read: false, update: false },
  taxSettings: { read: false, update: false },
  tags: { read: false, create: false, update: false, delete: false },
  technicians: { read: false, update: false },
  notifications: { read: false, cancel: false },
  discounts: { apply: false },
  coupons: { list: false, write: false, archive: false, apply: false },
};
